import { Chakra } from "@airhelp/react-ui-components";

const { Grid } = Chakra;

export interface Content {
  content: string;
}

interface BlogLegacyContentProps {
  content: Content;
  extraStyles: React.CSSProperties;
}

const styledContent = {
  a: {
    color: "primary.500",
    textDecoration: "underline",
  },
  p: {
    lineHeight: "tall",
    fontSize: "lg",
    mb: 8,

    a: {
      img: {
        borderRadius: "xl",
      },
    },
  },
  "li > p": {
    ml: 4,
  },
  "h1, h2, h3, h4": {
    mt: 14,
    mb: 6,
  },
  h2: {
    fontSize: "5xl",
    fontWeight: "bold",
  },
  h3: {
    fontSize: "xl",
    fontWeight: "bold",
  },
  li: {
    mb: 4,
    ml: 14,
  },
  "li::marker": {
    fontWeight: "semibold",
    fontSize: "2xl",
  },
  "ul li::marker": {
    fontWeight: "semibold",
    fontSize: "lg",
    color: "primary.500",
  },
  ul: {
    mb: 6,
    fontSize: "lg",
  },
  table: {
    display: { base: "block", md: "table" },
    overflowX: "auto",
    width: "100%",
    border: "1px solid",
    borderColor: "greyscale.300",
    borderCollapse: "separate",
    borderSpacing: 0,
    borderRadius: "2xl",
    borderLeft: 0,
    color: "greyscale.700",

    th: {
      fontWeight: "semibold",
      backgroundColor: "greyscale.300",
    },
    td: {
      borderTop: "1px solid",
      borderColor: "greyscale.300",
    },
    "th, td": {
      textAlign: "left",
      borderLeft: "1px solid",
      borderBottom: "1px solid",
      borderColor: "greyscale.300",
      padding: 4,
    },
    tr: {
      "&:first-of-type": {
        "th, td": {
          "&:first-of-type": {
            borderTopLeftRadius: "lg",
          },

          "&:last-child": {
            borderTopRightRadius: "lg",
          },
        },
        th: {
          paddingTop: 2,
          paddingBottom: 2,
        },
        td: {
          borderTop: "none",
        },
      },
      "&:last-child": {
        "th, td": {
          borderBottom: 0,

          "&:first-of-type": {
            borderBottomLeftRadius: "lg",
          },
        },
      },
    },
  },
  figure: {
    width: "initial!important",
    mb: 6,
  },
  img: {
    width: "100%",
    borderRadius: "xl",
  },
  blockquote: {
    mb: 8,
    backgroundColor: "neutral.100",
    position: "relative",
    overflow: "hidden",
    borderRadius: "xl",

    p: {
      mb: 0,
      p: 6,
      pt: 4,
    },

    "&:before": {
      content: "url(https://img.airhelp.com/components/quotes-in-a-green-circle.svg)",
      display: "block",
      width: 8,
      height: 8,
      mt: 6,
      ml: 6,
    },

    "&:after": {
      content: "url(https://img.airhelp.com/components/quotes.svg)",
      display: "block",
      position: "absolute",
      bottom: 0,
      right: "60px",
      mb: "-5px",
    },
  },
};

const BlogLegacyContent = ({ content: { content }, extraStyles = {} }: BlogLegacyContentProps) => (
  <Grid
    // @ts-ignore
    sx={{ ...styledContent, ...extraStyles }}
    dangerouslySetInnerHTML={{ __html: content }}
  />
);

export default BlogLegacyContent;
